import { createFileRoute, redirect } from "@tanstack/react-router";
import { classTasksRedirect } from "@/lib/staff-url-redirects";

export const Route = createFileRoute("/_protected/class-tasks/")({
  beforeLoad: () => {
    throw redirect(classTasksRedirect());
  },
  component: () => null,
});
